import api from '@/api'
import { ContactsStoredType } from '@contact/types/enums';

export default {
    getSharedContactsList(data: mail.api.DynamicApiOptions, personCode?: string): Promise<PagedItemList<contacts.ContactItem>> {
        var url = '/api/contact/share/list';
        if(personCode){
            url += '?personCode=' + personCode;
            data.type = 'Folder';
        }
        
        return api.post({ 
            url: url,
            data: {
                fields: [
                    { key: 'Id' },
                    { key: 'DisplayName' },
                    { key: 'Surname' },
                    { key: 'GivenName' },
                    { key: 'CompanyName' },
                    { key: 'Department' },
                    { key: 'JobTitle' },
                    { key: 'OfficeLocation' },
                    { key: 'ItemClass' },
                    { key: 'HasPicture' },
                    { key: 'PhoneNumbers', indexedKey: 'MobilePhone', as: 'mobile'},
                    { key: 'PhoneNumbers', indexedKey: 'BusinessPhone', as: 'businessPhone'},
                    { key: 'PhoneNumbers', indexedKey: 'BusinessFax', as: 'businessFax'},
                    { key: 'EmailAddresses', indexedKey: 'EmailAddress1', format: '{address}', as: 'email'},
                    { key: 'PhysicalAddresses', indexedKey: 'BusinessAddressStreet', serialize: true, as: 'businessAddress'},
                    { key: 'PhysicalAddresses', indexedKey: 'HomeAddressStreet', serialize: true, as: 'homeAddress'},
                    { key: 'BusinessHomePage', indexedKey: 'BusinessHomePage' },
                    {
                        key: 'Attachments',
                        indexedKey: 'Attachments',
                        serialize: true,
                        filters: [
                            { key: 'isContactPhoto', value: true, operator: 'eq' }
                        ]
                    },
                    { key: 'USER_IS_FAVORITE'},
                    ...data.fields
                ],
                filters: data.filters,
                parentId: data.parentId,
                pageSize: data.pageSize,
                offset: data.offset,
                sorts: data.sorts,
                wellKnownParentName: data.wellKnownParentName,
                type: data.type

            } as mail.api.DynamicApiOptions
        }).then((res) => {
            let rlt = res as PagedItemList<contacts.ContactItem>;
            let list = rlt.items;
            for(var item of list){
                item = {
                    ...item,
                    selected: false,
                    type: item.type
                }
            }
            rlt.items = list;
            
            return rlt;
        });

    },
    
    getSharingTargetList(data: mail.api.DynamicApiOptions): Promise<PagedItemList<contacts.ContactItem>>{
        return api.post({
            url: '/api/contact/share/target',
            data:{
                id: data.id,
                type: data.type === 'Contact' ? 'C' : 'F'
            }
        })
    },

    addShare(data: mail.api.DynamicApiOptions, storedType: ContactsStoredType){
        return api.post({
            url: '/api/contact/share/set?type='+ storedType,
            data: {
                fields: data.fields,
                id: data.id,
                type: data.type === 'Contact' ? 'C' : 'F'
            }
        })
    },

    removeShare(data: mail.api.DynamicApiOptions, storedType: ContactsStoredType): Promise<boolean>{
        return api.delete({
            url: '/api/contact/share?type=' + storedType,
            data: {
                fields: data.fields,
                id: data.id,
                type: data.type === 'Contact' ? 'C' : 'F'
            }
        })
    }
}